var _defs, _rect, _path, _path2, _rect2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_0029_bug_fixed",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    "data-imageid": "bug-fixing-46",
    imageName: "Bug Fixing",
    className: "illustrations_image",
    style: {
      width: 158
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1_bug-fixing-46{fill:url(#linear-gradient-13-bug-fixing-46);}.cls-1_bug-fixing-46,.cls-2_bug-fixing-46,.cls-3_bug-fixing-46,.cls-4_bug-fixing-46,.cls-5_bug-fixing-46,.cls-6_bug-fixing-46,.cls-7_bug-fixing-46,.cls-8_bug-fixing-46,.cls-9_bug-fixing-46,.cls-10_bug-fixing-46,.cls-11_bug-fixing-46,.cls-12_bug-fixing-46,.cls-13_bug-fixing-46,.cls-14_bug-fixing-46,.cls-15_bug-fixing-46,.cls-16_bug-fixing-46,.cls-17_bug-fixing-46{stroke-width:0px;}.cls-1_bug-fixing-46,.cls-3_bug-fixing-46,.cls-13_bug-fixing-46,.cls-14_bug-fixing-46{isolation:isolate;}.cls-1_bug-fixing-46,.cls-13_bug-fixing-46,.cls-14_bug-fixing-46{opacity:.19;}.cls-2_bug-fixing-46{fill:url(#linear-gradient);}.cls-3_bug-fixing-46{opacity:.18;}.cls-3_bug-fixing-46,.cls-17_bug-fixing-46{fill:#68e1fd;}.cls-4_bug-fixing-46{fill:url(#linear-gradient-11-bug-fixing-46);}.cls-5_bug-fixing-46{fill:url(#linear-gradient-12-bug-fixing-46);}.cls-6_bug-fixing-46{fill:url(#linear-gradient-10-bug-fixing-46);}.cls-7_bug-fixing-46{fill:url(#linear-gradient-4-bug-fixing-46);}.cls-8_bug-fixing-46{fill:url(#linear-gradient-2-bug-fixing-46);}.cls-9_bug-fixing-46{fill:url(#linear-gradient-3-bug-fixing-46);}.cls-10_bug-fixing-46{fill:url(#linear-gradient-8-bug-fixing-46);}.cls-11_bug-fixing-46{fill:url(#linear-gradient-7-bug-fixing-46);}.cls-12_bug-fixing-46{fill:url(#linear-gradient-6-bug-fixing-46);}.cls-13_bug-fixing-46{fill:url(#linear-gradient-5-bug-fixing-46);}.cls-14_bug-fixing-46{fill:url(#linear-gradient-9-bug-fixing-46);}.cls-15_bug-fixing-46{fill:#231f20;}.cls-16_bug-fixing-46{fill:#ffb4a3;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-bug-fixing-46",
    x1: 244.32,
    y1: 355.16,
    x2: 243.34,
    y2: 441.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2-bug-fixing-46",
    x1: -1040.49,
    y1: 4666.22,
    x2: -1040.49,
    y2: 4364.39,
    gradientTransform: "translate(1288.07 4783.52) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#fff",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#fff",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#fff",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3-bug-fixing-46",
    x1: 247.89,
    y1: 295.27,
    x2: 246.59,
    y2: 428.2,
    xlinkHref: "#linear-gradient-bug-fixing-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4-bug-fixing-46",
    x1: 244.02,
    y1: 368.26,
    x2: 245.32,
    y2: 426.9,
    xlinkHref: "#linear-gradient-bug-fixing-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5-bug-fixing-46",
    x1: -978.81,
    y1: 4515.91,
    x2: -847.59,
    y2: 4515.91,
    gradientTransform: "translate(1288.07 4783.52) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68e1fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6-bug-fixing-46",
    x1: -1027.75,
    y1: 4639.21,
    x2: -1066.74,
    y2: 4470.5,
    gradientTransform: "translate(1288.07 4783.52) scale(1 -1)",
    xlinkHref: "#linear-gradient-bug-fixing-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7-bug-fixing-46",
    x1: -1020.83,
    y1: 4637.61,
    x2: -1059.83,
    y2: 4468.9,
    gradientTransform: "translate(1288.07 4783.52) scale(1 -1)",
    xlinkHref: "#linear-gradient-bug-fixing-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8-bug-fixing-46",
    x1: -1062.24,
    y1: 4647.18,
    x2: -1101.23,
    y2: 4478.47,
    gradientTransform: "translate(1288.07 4783.52) scale(1 -1)",
    xlinkHref: "#linear-gradient-bug-fixing-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9-bug-fixing-46",
    x1: -881.9,
    y1: 4520.15,
    x2: -991.42,
    y2: 4505.25,
    xlinkHref: "#linear-gradient-5-bug-fixing-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10-bug-fixing-46",
    x1: -971.05,
    y1: 4603.69,
    x2: -938.69,
    y2: 4603.69,
    gradientTransform: "translate(1288.07 4783.52) scale(1 -1)",
    xlinkHref: "#linear-gradient-bug-fixing-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11-bug-fixing-46",
    x1: -932.89,
    y1: 4618.09,
    x2: -881.83,
    y2: 4618.09,
    gradientTransform: "translate(1288.07 4783.52) scale(1 -1)",
    xlinkHref: "#linear-gradient-bug-fixing-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12-bug-fixing-46",
    x1: -952.02,
    y1: 4628.07,
    x2: -909.33,
    y2: 4590.18,
    gradientTransform: "translate(1288.07 4783.52) scale(1 -1)",
    xlinkHref: "#linear-gradient-bug-fixing-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13-bug-fixing-46",
    x1: -879.42,
    y1: 4439.35,
    x2: -807.67,
    y2: 4439.35,
    xlinkHref: "#linear-gradient-5-bug-fixing-46"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "background_bug-fixing-46",
    className: "cls-3_bug-fixing-46 targetColor",
    d: "M408.65,398.29c-12.31,7.58-18.46,7.8-32.92,7.8-32.79,0-65.57-.15-98.36-.46l6.79-2.61c.4-3.76-4.8-5.14-8.59-5.08l-171.53,2.51c-30.59.45-65.55-1-85.14-24.5-10.91-13.06-14.71-31.12-12.79-48.04,1.92-16.92,3.47-53.87,53.31-98.09,16.49-14.64,35.04,4.75,39.19-16.92,6.24-32.44-18.46-64.73-12.8-97.29,3.03-17.45,14.89-32.66,30.01-41.92,15.11-9.26,33.16-12.89,50.87-12.67,10.69.14,21.52,1.69,31.18,6.26,9.43,4.47,17.3,11.59,25.53,18.01,12.05,9.42,25.35,17.62,40.08,21.74,29.5,8.24,60.64-.64,91.07-4.09,26.37-2.97,53.97-1.64,77.99,9.61,24.03,11.26,43.84,33.81,46.59,60.2,3,28.81-13.53,60.2.49,85.55,3.94,7.13,11.64,12.2,13.94,19.99,4.03,13.6-8.17,34.57-1.31,61.31,4.04,15.77-11.28,36.69-26.8,45.29-6.89,3.82-27.32-4.77-56.79,13.38Z",
    style: {
      fill: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "monitor_bug-fixing-46"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17_bug-fixing-46 targetColor",
    x: 190.97,
    y: 366.38,
    width: 105.98,
    height: 41.34,
    style: {
      fill: "rgb(204, 204, 204)"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2_bug-fixing-46",
    x: 190.97,
    y: 366.38,
    width: 105.98,
    height: 41.34
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17_bug-fixing-46 targetColor",
    d: "M440.48,113.4v230.41c0,14.02-11.37,25.39-25.39,25.39H80.08c-14.02,0-25.39-11.37-25.39-25.39,0,0,0-.02,0-.02V113.38c0-14.02,11.36-25.39,25.39-25.39h335c14.03,0,25.4,11.38,25.39,25.4h0Z",
    style: {
      fill: "rgb(204, 204, 204)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8_bug-fixing-46",
    d: "M440.48,113.4v230.41c0,14.02-11.37,25.39-25.39,25.39H80.08c-14.02,0-25.39-11.37-25.39-25.39,0,0,0-.02,0-.02V113.38c0-14.02,11.36-25.39,25.39-25.39h335c14.03,0,25.4,11.38,25.39,25.4h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17_bug-fixing-46 targetColor",
    d: "M440.48,308.98v34.8c0,14.02-11.36,25.38-25.37,25.39H80.08c-14.02,0-25.39-11.37-25.39-25.39h0v-34.8h385.78Z",
    style: {
      fill: "rgb(204, 204, 204)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9_bug-fixing-46",
    d: "M440.48,308.98v34.8c0,14.02-11.36,25.38-25.37,25.39H80.08c-14.02,0-25.39-11.37-25.39-25.39h0v-34.8h385.78Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17_bug-fixing-46 targetColor",
    x: 161.69,
    y: 401.87,
    width: 166.3,
    height: 6.79,
    style: {
      fill: "rgb(204, 204, 204)"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7_bug-fixing-46",
    x: 161.69,
    y: 401.87,
    width: 166.3,
    height: 6.79
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "shadow_bug-fixing-46",
    className: "cls-13_bug-fixing-46",
    d: "M440.48,341.84v1.95c0,8.72-4.47,16.83-11.84,21.47-2.64,1.14-5.36,2.11-8.12,2.9-6.88-14.94-13.77-29.87-20.64-44.8-2.25-4.87-4.57-9.85-7.43-14.38-2.35-3.86-5.31-7.33-8.75-10.27l-.53,10.27c-.16,3.05-.33,6.1-.48,9.15-.09,1.78-.23,3.66-1.26,5.11-1.94,2.71-6.3,2.53-8.94.5-2.64-2.03-4-5.29-5.18-8.4-.82-2.11-1.61-4.24-2.38-6.37-2.83-7.7-5.45-15.47-7.86-23.32-9.96-1.51-17.58-12.04-15.94-21.94.38-2.29,1.19-4.48,1.59-6.75.56-2.97.47-6.05.39-9.09l-1.34-47.75c-4.68-.14-9.34-.7-13.92-1.66-.59,4.43-4.66,7.56-9.09,6.97-2.24-.3-4.25-1.51-5.55-3.35-1.41-1.99-1.84-4.5-2.17-6.92-.46-3.4-3.34-15.91-.56-18.47,2.48-2.29,11.48.46,15.19-.45,4.89-1.19,9.44-3.48,14.16-5.22,7.65-2.81,15.77-4.16,23.92-3.98,5.89.13,11.98,1.14,16.84,4.49,4.86,3.35,8.14,9.46,6.75,15.19-2.81.94-4.96-2.85-7.86-3.46-1.44-.3-2.91.23-4.29.74-5.46,2.06-10.91,4.12-16.37,6.18-1.03.39-2.14.83-2.71,1.78s-.46,2.16-.29,3.27c1.2,7.53,4.13,14.68,8.57,20.89,3.96,5.53,9.06,10.24,12.58,16.07,3.52,5.83,5.23,13.47,1.83,19.36-.27.38-.46.82-.54,1.28-.09.99.77,1.75,1.55,2.38,18.44,14.25,32.04,33.33,43.62,53.77,6.1,10.74,11.65,21.85,17.07,32.86Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bug_bug-fixing-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12_bug-fixing-46",
    d: "M240.21,187.76c-.03-.07-.05-.15-.08-.23-.66-2.29-1.57-4.5-2.73-6.59-1.88-3.33-4.75-6.83-8.91-7.51-.98-.21-1.61-1.19-1.39-2.17.2-.91,1.06-1.53,1.99-1.42,10.24,1.7,14.15,15.23,14.54,16.69,4.04-1.13,8.3-1.16,12.35-.07.48-1.73,4.39-14.94,14.52-16.63,1-.11,1.9.61,2.02,1.61.11.93-.51,1.79-1.42,1.99-4.13.68-7.03,4.16-8.91,7.51-1.16,2.08-2.07,4.29-2.73,6.59l-.04.14c6.17,2.7,11.28,7.98,14.48,14.74h-47.93c3.13-6.67,8.17-11.91,14.25-14.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11_bug-fixing-46",
    d: "M277.34,220.08c-.11,2.46-.45,4.9-1.02,7.29h8.21c1.51,0,2.74,1.21,2.74,2.72,0,.73-.29,1.43-.8,1.94-.52.51-1.21.79-1.94.8h-8.53c-.46,0-.91-.11-1.31-.34-.71,1.77-1.56,3.47-2.55,5.1h5.39c1.51,0,2.73,1.22,2.73,2.73s-1.22,2.73-2.73,2.73h-8.53c-.31,0-.62-.05-.91-.15-4.84,5.11-11.21,8.21-18.18,8.21s-13.38-3.12-18.22-8.25c-.32.13-.66.19-1,.19h-8.53c-1.51,0-2.73-1.21-2.73-2.72h0c0-1.52,1.21-2.74,2.72-2.74h5.53c-1-1.65-1.86-3.37-2.57-5.16-.43.27-.92.41-1.42.4h-8.53c-1.51,0-2.73-1.22-2.73-2.73s1.22-2.73,2.73-2.73h8.36c-.57-2.38-.91-4.81-1.01-7.25h-8.43c-1.51.07-2.79-1.1-2.86-2.61-.07-1.51,1.1-2.79,2.61-2.86.08,0,.17,0,.26,0h8.59c.2-2.07.56-4.11,1.09-6.12h52.37c.54,2.03.9,4.09,1.1,6.18.2-.04.39-.06.59-.07h8.53c1.51-.07,2.79,1.1,2.86,2.61.07,1.51-1.1,2.79-2.61,2.86-.08,0-.17,0-.26,0h-8.55c-.15,0-.31-.01-.46-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10_bug-fixing-46",
    d: "M211.32,186.68c-6.89,0-12.47,5.58-12.47,12.47s5.58,12.47,12.47,12.47,12.47-5.58,12.47-12.47h0c0-6.89-5.58-12.47-12.47-12.47ZM211.32,190.41c4.82,0,8.73,3.9,8.74,8.72h0c0,.77-.1,1.53-.29,2.27l-14.59-8.44c1.63-1.63,3.84-2.55,6.15-2.55ZM211.32,207.88c-4.83,0-8.74-3.92-8.74-8.75,0-.79.11-1.58.32-2.34l14.66,8.46c-1.65,1.68-3.9,2.62-6.25,2.62Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "hand_bug-fixing-46"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16_bug-fixing-46",
    d: "M480.4,377.23l-.07.05c-1.69,1.32-3.48,2.51-5.34,3.56h0c-2.99,1.73-6.18,3.09-9.5,4.07,0,0-50.7-75.83-56.84-81.5h0c-4.72-4.34-13.19-6.93-17.57-8.63-.92-.3-1.79-.72-2.59-1.27-1.81-1.64-9.08-27.95-14.1-35.74-5.48-8.5-5.56-12.7-3.56-14.65,1.13-.95,2.55-1.47,4.02-1.48,3.66-.26,7.91,1.1,7.91,1.1.98-1.91.71-3.93-.24-6.21-1.45-3.56-4.51-7.72-6.97-13.06-4.02-8.79,2.67-12.95,2.67-12.95,0,0,18.78,20.06,29.35,28.43,10.57,8.37,10.8,34.04,26.96,48.95,16.16,14.91,57.7,51.79,57.7,51.79,4.75,19.32-3.33,30.95-11.83,37.57Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14_bug-fixing-46",
    d: "M397.14,284.28c1.48,2.66,2.11,12.8-6.07,10.48-2.57-.72-5.3-.53-7.88-1.19-.85-.18-1.66-.53-2.38-1.03-1.53-1.19-1.78-3.35-2.13-5.26-1.43-8.22-6.12-15.58-7.72-23.75-.72-3.61-.88-7.49-2.84-10.6-1.19-1.89-3.08-3.94-2.21-5.99.4-.94,1.29-1.57,2.15-2.14.89-.62,1.82-1.18,2.79-1.66.17-.08.34-.16.51-.23.84-.33,1.72-.53,2.55-.86.33-.12.65-.26.96-.4,3.66-.26,7.91,1.1,7.91,1.1.98-1.91.71-3.93-.24-6.21,2.9,2.38,12.42,15.13,9.58,27.35-.49,1.91-4.45,3.43,5.02,20.39Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17_bug-fixing-46 targetColor",
    d: "M309.14,173.43l9.22-3.22,1.37,2.58s48.21-20.33,66.66-20.78c18.45-.45,25.29,16.16,27.56,26.85,0,0-16.03-16.63-38.4-9.79-22.36,6.84-51.27,16.77-51.27,16.77l.91,4.16-8.87,3.41-7.17-19.98Z",
    style: {
      fill: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17_bug-fixing-46 targetColor",
    d: "M336.03,165.78l7.03,18.3c.77,2.02,2.94,3.13,5.03,2.59l13.66-3.53c2.01-.52,3.36-2.42,3.17-4.49l-1.83-20.7c-.21-2.34-2.28-4.07-4.62-3.86-.3.03-.6.09-.89.18l-18.86,5.94c-2.24.71-3.48,3.1-2.77,5.33.03.08.05.16.08.24Z",
    style: {
      fill: "rgb(204, 204, 204)"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6_bug-fixing-46",
    d: "M341.5,180.02c-10.01,3.34-17.22,5.82-17.22,5.82l.91,4.16-8.87,3.41-7.17-19.99,9.22-3.22,1.37,2.58s6.89-2.91,16.47-6.53l5.3,13.77Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4_bug-fixing-46",
    d: "M413.94,178.86s-16.03-16.63-38.4-9.79c-3.6,1.1-7.38,2.28-11.17,3.49l-1.29-14.6c-.03-.33-.1-.66-.21-.97,9.15-2.77,17.77-4.84,23.5-4.98,18.45-.45,25.29,16.16,27.56,26.85Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5_bug-fixing-46",
    d: "M361.75,183.14l-13.66,3.53c-2.09.54-4.26-.57-5.03-2.59l-1.56-4.06-5.3-13.78-.17-.45c-.84-2.19.25-4.65,2.44-5.5.08-.03.16-.06.25-.09l18.86-5.94c2.21-.7,4.57.51,5.3,2.71.11.31.18.64.21.97l1.29,14.6.54,6.1c.19,2.07-1.16,3.98-3.17,4.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15_bug-fixing-46",
    d: "M348.09,186.67l28.8,134.98s6.53,11.11,16.21,8.12c9.67-2.99-.98-39-12.03-72.18-11.05-33.18-19.23-66.51-19.32-74.42l-13.66,3.5Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16_bug-fixing-46",
    d: "M359.95,242.26s-12.03,3.32-9.88,9.33,22.73,11.02,33.63,8.97c10.9-2.05,8.25-6.78,4.68-8.97-3.57-2.19-27.55-5.17-27.55-5.17l-.88-4.16Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16_bug-fixing-46",
    d: "M354.37,255.63s-7.91,6.14-5.01,11.76,32.3,7.75,37.74,6.15c5.44-1.6,3.14-7.19,1.57-8.31-1.74-1.46-3.4-3.01-4.98-4.64,0,0-15.17,2.19-29.33-4.95Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16_bug-fixing-46",
    d: "M355.53,282.16s-5.71-8.11,3.06-10.47c0,0,22.85,3.67,28.5,1.84,0,0,6.63,2.61,5.99,7.33-.81,6.07-34.07,7.05-37.55,1.3Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16_bug-fixing-46",
    d: "M368.47,295.89s20.19,1.66,23.44-3.15c3.25-4.82-3.25-8.46-3.25-8.46,0,0-19.16,2.55-24.98,1.12-5.83-1.43-7.26,7.6,4.79,10.49Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1_bug-fixing-46",
    d: "M480.4,377.23l-.07.05c-.42.3-2.67,1.9-5.34,3.56h0c-3.42,2.11-7.55,4.31-9.5,4.07,0,0-50.63-75.84-56.76-81.51h0s7.05.08,14.76,5.59c7.71,5.5,56.91,68.24,56.91,68.24Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.a3d9709c038750055ac050559c498669.svg";
export { ForwardRef as ReactComponent };